import { useEffect, createElement, lazy } from "react";

import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import FSComments from "../components/FSComments";
import MainLayout from "../components/layouts/Main";
import VideoMeeting from "../components/video-meeting";
import { useAuth } from "../contexts/authContext";
import Auth from "../pages/auth";
import Meeting from "../pages/meeting";
import MeetingDetails from "../pages/meeting/details";
import Search from "../pages/search";
import Settings from "../pages/settings";
import StreamPage from "../pages/streamjs";
import S3Page from "../pages/s3js";
import ScreenPage from "../pages/screenjs";

const NotFound = lazy(() => import("../pages/not-found/NotFound"));

const CRoute = ({ component, ...props }) => <Route {...props} render={() => <MainLayout>{createElement(component)}</MainLayout>} />;

const AppRouter = () => {
  const { isLoggedIn } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <Switch>
      <Route exact path="/">
        {isLoggedIn ? <Redirect to="/live" /> : <Redirect to="/login" />}
      </Route>
      <CRoute exact path="/live" component={Meeting} />
      <CRoute exact path="/live/active" component={() => <Meeting filter="active" />} />
      <CRoute exact path="/live/upcoming" component={() => <Meeting filter="upcoming" />} />
      <CRoute exact path="/live/past" component={() => <Meeting filter="past" />} />
      <CRoute exact path="/live/create" component={() => <Meeting showCreate />} />
      <CRoute exact path="/live/:meetingId" component={MeetingDetails} />
      <CRoute exact path="/search" component={Search} />
      <CRoute exact path="/settings" component={Settings} />
      <CRoute exact path="/streamjs" component={StreamPage} />
      <CRoute exact path="/s3js" component={S3Page} />
      <CRoute exact path="/screenjs" component={ScreenPage} />
      <Route exact path="/video" component={VideoMeeting} />
      <Route exact path="/comments" component={FSComments} />
      <Route exact path="/login" component={Auth} />
      <Route path="/404" component={NotFound} />
      <Redirect to="/404" />
    </Switch>
  );
};

export default AppRouter;
